import React, { useState, useEffect, Fragment } from "react";
import { Button } from "react-bootstrap";
export function Gotobottom1() {
  const [Gotobottom, setGotobottom] = useState();
  useEffect(() => {
    window.addEventListener("scroll", () => {
      (window.scrollY <= document.documentElement.scrollHeight - document.documentElement.clientHeight - 20) ? setGotobottom('d-block') : setGotobottom('');
    });
  }, []);
  const screenup = () => {
    window.scrollTo(0, document.documentElement.scrollHeight);
  };
  return (
    <Fragment>
      <Button className={`${Gotobottom} mg-r-50`} id="back-to-top" onClick={screenup}>
        <i className="fe fe-arrow-down fs-14 pr-10"></i>
      </Button>
    </Fragment>
  );
}
Gotobottom1.propTypes = {};

Gotobottom1.defaultProps = {};
